module.exports = {
    topHead: {
        select_option_category: "Category",
        select_option_category_holder: "You can enter Title keywords or product links to search",
        select_option_brand: "Brand",
        select_option_brand_holder: "Please select",
        select_option_postKeyWords: "PostKeywords",
        select_option_postKeyWords_holder: "Please enter the content",
        rules_message_search: "Enter at least one brand or post content",
        my_attention: "MyAttention",
        login_label: "SignIn",
        login_out: "SignOut",
        Chinese: "中文",
        English: "English",
    },
    inspiration: {
        amazon: "Amazon",
        amazon_us: "Amazon US",
        amazon_de: "Amazon DE",
        amazon_es: "Amazon ES",
        amazon_fr: "Amazon FR",
        amazon_it: "Amazon IT",
        amazon_uk: "Amazon UK",
        amazon_jp: "Amazon JP",
        shopee: "Shopee",
        shopee_vn: "Shopee VN",
        shopee_th: "Shopee TH",
        shopee_sg: "Shopee SG",
        shopee_my: "Shopee MY",
        shopee_ph: "Shopee PH",
        shopee_id: "Shopee ID",
        shopee_tw: "Shopee TW, China",
        lazada: "Lazada",
        lazada_vn: "Lazada VN",
        lazada_th: "Lazada TH",
        lazada_sg: "Lazada SG",
        lazada_my: "Lazada MY",
        lazada_ph: "Lazada PH",
        lazada_id: "Lazada ID",
    },
    inspTh: {
        analyze_name: "Analyze name",
        product_name: "Product name",
        plat: "Plat and cats",
        publish_user: "Publish user",
        publish_time: "Publish time",
        share_count: "Share count",
        operation: "Operation",
    },
};